import React from 'react';
import AppTypography from '../../core/Typography/AppTypography';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Context from './context';
import clsx from 'clsx';
import AppAvatar from '../../core/Avatar/AppAvatar';

const Business = ({ businesses = [] }) => {
  const { classes } = React.useContext(Context);

  return (
    <div>
      <AppTypography
        size={18}
        weight="bold"
        mb={2.5}
        color="palette.text.primary"
      >
        受け入れ先について知る
      </AppTypography>
      <Grid container alignItems="center" spacing={2}>
        {businesses.map(({ url, name, imageUrl }) => (
          <Grid item xs={12} sm={6} md={4} key={url}>
            {React.createElement(
              !!url ? Link : 'div',
              { className: classes.business, ...(!!url && { href: url }) },
              <>
                <AppAvatar
                  src={imageUrl}
                  loaded
                  className={classes.businessImage}
                />
                <Typography
                  color="textPrimary"
                  className={clsx(classes.businessName, 'text-break-all')}
                >
                  {name}
                </Typography>
                <KeyboardArrowRightIcon className={classes.businessArrow} />
              </>,
            )}
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Business;
